import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../data/mock";
import LogoMark from "./LogoMark";

const Logo = ({ dark = false }) => (
  <Link to="/" className="flex items-center gap-3 group">
    <LogoMark size={44} className="shrink-0 transition-transform duration-300 group-hover:scale-105" />
    <div className="leading-tight">
      <div className={`font-serif text-[19px] font-bold tracking-tight ${dark ? "text-[#16233f]" : "text-white"}`}>
        PT Hiring Solutions
      </div>
      <div className="text-[9px] tracking-[0.28em] text-[var(--gold)] font-medium uppercase">
        Finding Talent. Driving Success.
      </div>
    </div>
  </Link>
);

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0d1526]/90 backdrop-blur-md py-3 shadow-lg shadow-black/20"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-8 flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              end={l.path === "/"}
              className={({ isActive }) =>
                `nav-link text-[14.5px] text-white/85 hover:text-white ${isActive ? "active text-white" : ""}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link
            to="/contact"
            className="btn-gold px-6 py-2.5 rounded-sm text-[14px] inline-block"
          >
            Get in Touch
          </Link>
        </div>

        <button
          className="lg:hidden text-white p-1"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 bg-[#0d1526] ${
          open ? "max-h-[520px] border-t border-white/10" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-6 py-6 gap-5">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              end={l.path === "/"}
              className={({ isActive }) =>
                `text-white/85 text-lg font-serif ${isActive ? "text-[var(--gold)]" : ""}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn-gold px-6 py-3 rounded-sm text-center mt-2">
            Get in Touch
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
